var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showModal)?_c('div',{staticClass:"modal"},[_c('div',{staticClass:"modal-content"},[_c('span',{staticClass:"close",on:{"click":_vm.closeModal}},[_vm._v("×")]),_c('div',{staticClass:"player-container",attrs:{"id":"playercontainer"}})])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }